import { AdminService } from "../services/admin-service";
import { NotifyService } from "../services/notify-service";

export function RLJobProgressStatusMonitor() {
    var directive: ng.IDirective = {
        restrict: "AE",
        replace: true,
        template: require("/assets/app/templates/job-progress-status.html"),
        controller: RLJobProgressStatusMonitorController,
        controllerAs: "jpsVM",
        bindToController: true,
        scope: {
            progressJobID: "=progressJobId",
            jobTitle: "=",
            progressStatus: "=?",
            allowJobCancel: "=",
            hideProgressModal: "=",
            showProgressSpinner: "=?",
            onCompleteCallback: "&?",
            resultMessage: "=?",
            progressResultData: "=?",
            progressMessageFormatter: "&?",
            resultMessageFormatter: "&?"
        }
    };
    return directive;
}

class RLJobProgressStatusMonitorController {

    public static $inject = [
        "$scope",
        "$q",
        "adminService",
        "notifyService",
        "$interval"
    ];

    jobTitle: string;
    progressJobID: string;
    public progressModalOpen: boolean;
    progressStatus: string;
    progressComplete: number;
    progressFailed: number;
    progressFailedPercentage: number;
    progressTotal: number;
    progressPercentage: number;
    progressMessage: string;
    progressIntervalPromise: ng.IPromise<any>;
    onCompleteCallback: (event: { data: string }) => any;
    allowJobCancel: boolean;
    hideProgressModal: boolean;
    progressClass: string;
    showProgressSpinner: boolean;
    resultMessage: string;
    progressResultData: string;
    resultMessageFormatter: (event: { data: string }) => string;
    progressMessageFormatter: (event: { data: string }) => string;

    public constructor(private $scope: ng.IScope,
        private readonly $q: ng.IQService,
        private readonly adminService: AdminService,
        private readonly notifyService: NotifyService,
        private readonly $interval: ng.IIntervalService) {
    }

    $onInit() {
        this.progressModalOpen = false;
        this.progressStatus = "";
        this.progressComplete = 0;
        this.progressFailed = 0;
        this.progressTotal = 0;
        this.progressPercentage = 0;
        this.progressFailedPercentage = 0;
        this.progressIntervalPromise = null;
        this.progressClass = "progress-bar-success";
        this.resultMessage = "";
        this.progressResultData = "";
        //this.showProgressSpinner = false;

        this.$scope.$watch(() => this.progressJobID,
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    this.ShowProgress();
                }
            });
    }

    ShowProgress() {
        this.notifyService.startProgress();
        this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
        this.UpdateProgress();
        this.progressModalOpen = true;
    }

    UpdateProgress() {
        this.adminService.getJobState(this.progressJobID)
            .then((result) => {
                this.progressComplete = result.completed;
                this.progressFailed = result.failed;
                this.progressStatus = result.statusDescription;
                this.progressTotal = result.total;
                this.progressMessage = result.progressMessage;
                this.resultMessage = this.FormatProgressMessage(result.resultMessage);

                this.progressPercentage = (this.progressComplete / this.progressTotal) * 100;
                this.progressFailedPercentage = (this.progressFailed / this.progressTotal) * 100;
                if (this.progressFailed > 0 || result.status === "Failed") {
                    this.progressClass = "progress-bar-warning";
                }

                if (result.status === "Done" || result.status === "Failed" || result.status === "Cancelled") {
                    this.resultMessage = this.FormatResultMessage(result.resultMessage);
                    this.progressResultData = result.progressResultData;
                    this.$interval.cancel(this.progressIntervalPromise);
                    if (this.onCompleteCallback) {
                        this.$q.when(this.onCompleteCallback({ data: this.progressResultData }))
                            .then(() => {
                                this.notifyService.endProgress();
                            });
                    } else {
                        this.notifyService.endProgress();
                    }
                }
            });
    }

    CancelJob() {
        this.adminService.cancelJob(this.progressJobID).then(() => { });
    }

    FormatResultMessage(message: string): string {
        if (this.resultMessageFormatter && message) {
            return this.resultMessageFormatter({ data: message });
        }

        return message;
    }

    FormatProgressMessage(message: string): string {
        if (this.progressMessageFormatter && message) {
            return this.progressMessageFormatter({ data: message });
        }

        return message;
    }
}